import api from '../api';
import { authApi } from '../apiVariables';

const handleApiCall = (apiConfig: any) => {
  return new Promise((resolve, reject) => {
    api(apiConfig).then(resolve).catch(reject);
  });
};

export const login = async (body: any) => {
  const { login } = authApi;
  return await handleApiCall({ ...login, body });
};
export const logout = async () => {
  try {
    await handleApiCall({
      api: "/api/auth/logout",
      method: "post",
      baseurl: "baseurl",
      isPublic: true,
    });
  } catch (err) {
    console.error("Logout API failed", err);
  }
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('user');
  sessionStorage.removeItem('chatMessages');
  return true;
};
export const isLoggedIn = () => {
  // Check if isLoggedIn flag exists since we cannot read the HttpOnly cookie
  const loggedInStr = localStorage.getItem('isLoggedIn');
  if (!loggedInStr || loggedInStr !== 'true') {
    return false; // User is not logged in
  }

  return true; // User is logged in
};
export const forgetPassword = (body: any) => {
  const { forgetPassword: forgetPasswordConfig } = authApi;

  const apiConfig = { ...forgetPasswordConfig, body };
  return handleApiCall(apiConfig);
};

export const resetPassword = (body: any) => {
  const { resetPassword } = authApi;
  return handleApiCall({ ...resetPassword, body });
};
export const logEvent = (body: any) => {
  const { logLoginLogout } = authApi;
  return handleApiCall({ ...logLoginLogout, body });
};

export const getUserRole = () => {
  const { userRole: userRoleConfig } = authApi;
  return handleApiCall({ ...userRoleConfig });
};

// services/ApiActions/authAct.ts

export const isAdmin = (): boolean => {
  // Pull your user context/data object from wherever you cache it (localStorage, cookies, session)
  const userRole = localStorage.getItem("userRole"); 
  
  if (!userRole) return false;

  try {
    // const user = JSON.parse(userRole);
    // Adjust 'admin' to match the exact string key of your administrative role
    return userRole === 'admin'; 
  } catch (error) {
    return false;
  }
};